import secondaryComponents from "../../../components/secondaryComponents";
import { useNavigate } from "react-router-dom";
import { CheckoutView } from "../../../components/secondaryComponents/SellModeItemsV2";

export const CheckoutHome = () => {
  const navigate = useNavigate();

  return (
    <secondaryComponents.Modal
      isActive={true}
      width={1300}
      padding={"0"}
      style={{ maxHeight: "100%", height: "100vh", borderRadius: "0" }}
      closeModal={() => navigate(-1)}
    >
      <CheckoutView />
    </secondaryComponents.Modal>
  );
};
